import React from 'react';
import { OrderedMap } from 'immutable';
import Store from '../../models/Store';
import connectToStores from 'fluxible-addons-react/connectToStores';
import BookmarkActions from '../../actions/BookmarkActions';
import Popover from '../../../client/components/Popover';
import shallowCompare from '../../lib/shallowCompare';
import InventoryRecordsList from '../InventoryRecordsList';
import { PhotoPositions, RemoveActions } from '../InventoryRecordListElement';
import styles from './index.sass';

class BookmarksList extends React.Component {
  static propTypes = {
    entities: React.PropTypes.instanceOf(OrderedMap),
    loading: React.PropTypes.bool,
    pagination: React.PropTypes.object,
    store: React.PropTypes.instanceOf(Store),
    className: React.PropTypes.string
  };

  static contextTypes = {
    executeAction: React.PropTypes.func,
    getUserAgent: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      requestedOffset: 0,
      loading: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.filters !== this.props.filters || nextProps.sorter !== this.props.sorter) {
      this.setState({requestedOffset: 0});
    }
    if(nextProps.loading !== this.props.loading) {
      this.setState({loading: nextProps.loading});
    }
  }

  handleOnClickLoadMoreButton(e) {
    let offset = this.props.pagination.offset + this.props.pagination.limit;
    if(offset <= this.state.requestedOffset) {return;}
    this.setState({
      loading: true,
      requestedOffset: offset
    });
    this.context.executeAction(BookmarkActions.list, {
      filters: this.props.filters,
      sorter: this.props.sorter,
      pagination: _.extend({}, this.props.pagination, {offset: offset})
    });
  }

  render() {
    let isMobile = this.context.getUserAgent().isMobile;
    let { store, entities, loading, pagination } = this.props;
    if(!entities) {entities = new OrderedMap();}
    let inventoryRecordsListProps = {
      className: styles.inventoryRecordsList,
      storeId: store.get('id'),
      inventoryRecords: entities,
      loading: loading,
      emptyText: 'Things you save will be listed here',
      inventoryRecordsListElementConfig: {
        onClickRemoveAction: RemoveActions.DeleteBookmark,
        photoPosition: isMobile ? PhotoPositions.Right : PhotoPositions.Left,
        showFeaturedBadge: false,
        showRatings: false,
        showBuyButton: true,
        showHeartButton: false,
        showDescription: false,
        showVariantPriceLine: true
      }
    };

    let classes = styles.bookmarksList;
    if(this.props.className) {
      classes += (' ' + this.props.className);
    }

    let loadMoreButton;
    if(!this.state.loading && entities.size < pagination.totalResults) {
      let loadMoreButtonProps = {
        className: styles.loadMoreButton,
        onClick: this.handleOnClickLoadMoreButton.bind(this)
      };
      loadMoreButton = <button {...loadMoreButtonProps}>See more</button>;
    }

    return (
      <div className={classes}>
        <InventoryRecordsList {...inventoryRecordsListProps} />
        {loadMoreButton}
      </div>
    );
  }
}

export default BookmarksList;



// WEBPACK FOOTER //
// banquet/components/BookmarksList/index.js